// ─────────────────────────────────────────────────────────────────────────────
// Preferred Products Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the preferredProducts store slice.
// Covers list, create, update, bulk-delete, import tracking, search, and
// filter actions.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { IPageCount } from 'src/app/shared/models/page.model';
import {
  ICreatePreferredProductPayload,
  IPreferredProduct,
  IUpdatePreferredProductPayload,
  PreferredProductFilters,
} from '../models/preferred-product.models';

// ── Load preferred products ─────────────────────────────────────────────────

export const LoadPreferredProducts = createAction(
  '[ PreferredProducts ] - LoadPreferredProducts',
  props<{ page: IPageCount; key?: string; filters?: PreferredProductFilters; sortBy?: string; sortMode?: 'asc' | 'desc' }>(),
);
export const LoadPreferredProductsSuccess = createAction(
  '[ PreferredProducts ] - LoadPreferredProducts Success ',
  props<{ response: APIResponse<IPreferredProduct> }>(),
);
export const LoadPreferredProductsError = createAction('[ PreferredProducts ] - LoadPreferredProducts Error');

// ── Create preferred product ────────────────────────────────────────────────

export const CreatePreferredProduct = createAction(
  '[ PreferredProduct ] - CreatePreferredProduct',
  props<{ payload: ICreatePreferredProductPayload }>(),
);
export const CreatePreferredProductSuccess = createAction(
  '[ PreferredProduct ] - CreatePreferredProduct Success ',
  props<{ preferredProduct: IPreferredProduct }>(),
);
export const CreatePreferredProductError = createAction('[ PreferredProduct ] - CreatePreferredProduct Error', props<{ error: string }>());

// ── Update preferred product ────────────────────────────────────────────────

export const UpdatePreferredProduct = createAction(
  '[ PreferredProduct ] - UpdatePreferredProduct',
  props<{ id: number; payload: IUpdatePreferredProductPayload }>(),
);
export const UpdatePreferredProductSuccess = createAction(
  '[ PreferredProduct ] - UpdatePreferredProduct Success ',
  props<{ preferredProduct: IPreferredProduct }>(),
);
export const UpdatePreferredProductError = createAction('[ PreferredProduct ] - UpdatePreferredProduct Error', props<{ error: string }>());

// ── Bulk delete preferred products ──────────────────────────────────────────

export const BulkDeletePreferredProducts = createAction('[ PreferredProducts ] - BulkDeletePreferredProducts', props<{ ids: number[] }>());
export const BulkDeletePreferredProductsSuccess = createAction('[ PreferredProducts ] - BulkDeletePreferredProducts Success ');
export const BulkDeletePreferredProductsError = createAction('[ PreferredProducts ] - BulkDeletePreferredProducts Error');

// ── Import tracking ──────────────────────────────────────────────────────────

export const ImportPreferredProducts = createAction('[ PreferredProducts ] - ImportPreferredProducts');
export const ImportPreferredProductsSuccess = createAction('[ PreferredProducts ] - ImportPreferredProducts Success ');
export const ImportPreferredProductsError = createAction('[ PreferredProducts ] - ImportPreferredProducts Error');

// ── Search ───────────────────────────────────────────────────────────────────

export const SetPreferredProductSearch = createAction('[ PreferredProducts ] - SetSearch', props<{ keyword: string }>());

// ── Filters ──────────────────────────────────────────────────────────────────

export const SetPreferredProductFilters = createAction('[ PreferredProducts ] - SetFilters', props<{ filters: PreferredProductFilters }>());
